import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Select, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { queryCustomList } from '@api/crm/crm';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [{ uuid: '1', name: '唉唉唉' }, { uuid: '2' }],
      total: 0,
      pageNo: 1,
    };
  }

  componentDidMount() {
    this.loadData(1);
  }

  loadData = (pageNo, condition) => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    this.setState({
      pageNo,
    });
    queryCustomList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      }
    });
  };

  handleChange = () => {};

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.loadData(1, values.condition);
      }
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.loadData(1);
  };

  handleModalVisible = () => {};

  showModal = () => {};

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSubmit}>
        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
          <Col md={8} sm={24}>
            <FormItem label="部门">
              {getFieldDecorator('condition')(
                <Select>
                  <Option key="1">部门一</Option>
                  <Option key="2">部门二</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <FormItem label="搜索条件">
              {getFieldDecorator('condition')(<Input placeholder="请输入关键字搜索" />)}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <span className="submitButtons">
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
                重置
              </Button>
            </span>
          </Col>
        </Row>
      </Form>
    );
  };

  onClose = () => {};

  showDrawer = () => {};

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '客户名称',
        dataIndex: 'name',
        render: text => {
          return <a onClick={this.showDrawer}>{text}</a>;
        },
      },
      {
        title: '所属行业',
        dataIndex: 'category',
      },
      {
        title: '所属地区',
        dataIndex: 'origin',
      },
      {
        title: '更新时间',
        dataIndex: 'updateTime',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
    ];
  };

  render() {
    const { data, total } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListForm">{this.renderSearchForm}</div>
          <div className="tableListOperator">
            <Link to="/crm/custom/add">
              <Button type="primary">导出</Button>
            </Link>
            <Link to="/client/manage/add">
              <Button>新建客户</Button>
            </Link>
          </div>
        </div>
        <Table
          rowKey="uuid"
          size="small"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/client/pool/Index.js